import { render, staticRenderFns } from "./PageIncompatible.vue?vue&type=template&id=6663db7b&"
import script from "./PageIncompatible.vue?vue&type=script&lang=js&"
export * from "./PageIncompatible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/bluehost-site-migrator/bluehost-site-migrator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6663db7b')) {
      api.createRecord('6663db7b', component.options)
    } else {
      api.reload('6663db7b', component.options)
    }
    module.hot.accept("./PageIncompatible.vue?vue&type=template&id=6663db7b&", function () {
      api.rerender('6663db7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "source/components/PageIncompatible.vue"
export default component.exports